import { Shield } from "@tamagui/lucide-icons";
import { Image } from "expo-image";
import { useContext } from "react";
import { View, XStack, YStack } from "tamagui";

import CuraiLogo from "@/assets/images/landing_page/general_care/curai-logo.png";
import CuraiLogoDark from "@/assets/images/landing_page/general_care/curai-logo-dark.png";
import ChatInput from "@/components/ChatInput";
import { LayoutContext } from "@/components/LayoutProvider";
import { Text } from "@/components/Typography";
import { useIsDarkTheme } from "@/theme/helpers";
import LandingGradientBackground from "./LandingGradientBackground";

export default function ReadyWhenYouAre() {
  const { lg } = useContext(LayoutContext);
  const isDark = useIsDarkTheme();

  return (
    <LandingGradientBackground>
      <YStack
        maxWidth="$landingPageConstraint"
        alignSelf="center"
        paddingHorizontal="$400"
        paddingVertical="$1000"
        width="100%"
        gap="$250"
        alignItems="center"
        position="relative"
        overflow="hidden"
      >
        <View
          position="absolute"
          pointerEvents="none"
          width={400}
          height={400}
          left="50%"
          top={lg ? "50%" : -30}
          style={
            lg
              ? { transform: [{ translateX: 100 }, { translateY: -200 }] }
              : { transform: [{ translateX: -200 }] }
          }
        >
          <Image
            source={isDark ? CuraiLogoDark : CuraiLogo}
            style={{ width: "100%", height: "100%" }}
            contentFit="contain"
          />
        </View>

        <YStack alignItems="center" gap="$100">
          <Text size="$xxl" textAlign="center">
            Ready when you are
          </Text>
          <Text size="$md" textAlign="center" color="$textSecondary">
            No appointments. No insurance. Just tell us what's going on.
          </Text>
        </YStack>

        <View width="100%" maxWidth={500} alignItems="center">
          <ChatInput
            key="chat-input-general-care-cta"
            dataTrackingId="chat-input-general-care-cta"
            extraTrackingContext={{ messageType: "landing-general-care-cta" }}
            placeholder="What can we help you with?"
          />
          <XStack gap="$150">
            <Shield size={14} color="$textSecondary" />
            <Text size="$xs" color="$textSecondary">
              HIPAA compliant · SOC2 certified
            </Text>
          </XStack>
        </View>
      </YStack>
    </LandingGradientBackground>
  );
}
